import Vue from 'vue'

Vue.filter('date', function (value) {
  if (value) {
    return new Date(value).toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    })
  }
})

Vue.filter('localizedDate', function (value) {
  if (value) {
    return new Date(value).toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    })
  }
})

Vue.filter('localizedDateEvents', function (value) {
  if (value) {
    return new Date(value).toLocaleDateString('ru-RU', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    })
  }
})
Vue.filter('localizedDateRu', function (value) {
  if (value) {
    return new Date(value).toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    })
  }
})
Vue.filter('localizedDateShort', function (value) {
  if (value) {
    return new Date(value).toLocaleDateString('ru-RU', {
      month: 'long',
      day: 'numeric'
    })
  }
})
Vue.filter('localizedTimer', function (value) {
  if (value) {
    return new Date(value).toLocaleTimeString('ru-RU', {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    })
  }
})

Vue.filter('number', function (value) {
  return Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(value || 0)
})

Vue.filter('wordend', function (value, words) {
  return `${value}
    ${words[((value % 100 > 10 && value % 100 < 15) || value % 10 > 4 || value % 10 === 0) ? 2 : (value % 10 === 1) ? 0 : 1]}`
})
